import { render, staticRenderFns } from "./DevolucionDialog.vue?vue&type=template&id=618bb9fb"
import script from "./DevolucionDialog.vue?vue&type=script&lang=js"
export * from "./DevolucionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports